import { z } from 'zod';

export enum ObjectType {
  Asset = 'asset',
  Folder = 'folder',
  Album = 'album',
  Node = 'node',
}

export enum ObjectAction {
  Move = 'move',
  Trash = 'trash',
  Update = 'update',
  Album_Asset_Update = 'album_asset_update',
  Duplicate = 'duplicate',
}

export const batchProgressSchema = z.object({
  progress: z.number(),
  totalJobs: z.number(),
  processedJobs: z.number(),
  pendingJobs: z.number(),
  failedJobs: z.number(),
  finished: z.boolean(),
  cancelled: z.boolean(),
  hasFailures: z.boolean(),
});

export type BatchProgress = z.infer<typeof batchProgressSchema>;

export interface BatchUpdateBody {
  objectType: ObjectType;
  objectAction: ObjectAction;
  filter: {
    includeSubFolderAssets?: boolean;
    assetIds?: Array<string>;
    folderId?: string;
    albumId?: string;
    searchQuery?: string;
  };
  payload: {
    parentFolderNodeId?: string; // Required if moving a node
    // Album Asset Update
    add?: boolean;
    remove?: boolean;
    albumId?: string; // Required for album asset updates

    // Asset Update
    workflows?: Record<string, any>;
    metadata?: Record<string, any>;
    tags?: Array<string>;
    tagIds?: Array<string>;

    // Asset Duplicate
    destinationFolderId?: string;
  };
}

/**
 * Narrows the shared BatchUpdateBody bag to what a duplicate call may send. The second filter
 * shape is "select all": selectedAssets there is only ever the loaded page, so the folder id
 * lets the backend resolve every asset in it instead.
 */
export interface DuplicateAssetsBatchBody {
  objectType: ObjectType.Asset;
  objectAction: ObjectAction.Duplicate;
  filter: { assetIds: Array<string> } | { folderId: string; includeSubFolderAssets: boolean };
  payload: { destinationFolderId: string };
}

export const batchUpdateResponseSchema = z.object({ batchId: z.string() });

export type BatchUpdateResponse = z.infer<typeof batchUpdateResponseSchema>;
